import { createApplicationService } from "./base/applicationServiceBase";
import { API } from "api/axios.config";
import { useMemo } from "react";

const SOURCES_BASE = "/sources";

const fetchSourcesAPI = () => API.get(`${SOURCES_BASE}`);

const addNewSourceAPI = (data) =>
  API.post(`${SOURCES_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateSourceAPI = (id, data) =>
  API.patch(`${SOURCES_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "sources",
  apiFetchFn: fetchSourcesAPI,
  apiAddFn: addNewSourceAPI,
  apiUpdateFn: updateSourceAPI,
});

const sourceReducer = baseService.reducer;
const getSources = baseService.getData;
const addSource = baseService.addData;
const updateSource = baseService.updateData;
const useSources = baseService.useData;

const useActiveSources = () => {
  const { data, loading } = useSources();
  const activeSources = useMemo(() => {
    return data
      .filter((s) => s.active)
      .sort((a, b) => {
        const nameA = (a.sourceName || "").toLowerCase();
        const nameB = (b.sourceName || "").toLowerCase();
        return nameA.localeCompare(nameB);
      });
  }, [data]);
  return { data: activeSources, loading };
};

export {
  sourceReducer,
  getSources,
  addSource,
  updateSource,
  useSources,
  useActiveSources,
};
